import React, { useState, useEffect } from 'react';
import './ProfileEditModal.css'; // Reusing your modal styles

const ReviewModal = ({ consultation, isOpen, onClose, onSubmit }) => {
  const [score, setScore] = useState(0);
  const [hoverScore, setHoverScore] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (consultation?.rating?.score) {
        setScore(consultation.rating.score);
        setReviewText(consultation.rating.review || '');
      } else {
        setScore(0);
        setReviewText('');
      }
    }
  }, [consultation, isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (score < 1) {
      alert("Please select a star rating.");
      return;
    }
    setIsSubmitting(true);
    await onSubmit(consultation._id, { score, review: reviewText });
    setIsSubmitting(false);
  };

  return (
    <div className="profile-modal-overlay" onClick={onClose}>
      <div className="profile-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <div className="profile-modal-header">
          <h3>{consultation?.rating?.score ? 'Edit Your Review' : 'Rate Your Consultation'}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="profile-modal-body">
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <p style={{ color: '#666', marginBottom: '10px' }}>
                How was your session with <strong>{consultation?.consultant?.displayName || 'your consultant'}</strong>?
              </p>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '5px', fontSize: '2.5rem', cursor: 'pointer' }}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <i 
                    key={star}
                    className={`fa-star ${star <= (hoverScore || score) ? 'fas' : 'far'}`}
                    style={{ color: star <= (hoverScore || score) ? '#f59e0b' : '#ddd', transition: 'color 0.2s' }}
                    onMouseEnter={() => setHoverScore(star)}
                    onMouseLeave={() => setHoverScore(0)}
                    onClick={() => setScore(star)}
                  ></i>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="reviewText">Write a review (Optional)</label>
              <textarea
                id="reviewText"
                rows="4"
                value={reviewText}
                onChange={(e) => setReviewText(e.target.value)}
                placeholder="Share your experience to help others..."
                style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc' }}
              ></textarea>
            </div>
            
            {consultation?.rating?.updatedAt && (
              <small style={{ display: 'block', textAlign: 'right', color: '#888', fontStyle: 'italic', marginTop: '10px' }}>
                Last edited: {new Date(consultation.rating.updatedAt).toLocaleDateString()}
              </small>
            )}
          </div>

          <div className="profile-modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-save" disabled={isSubmitting || score === 0}>
              {isSubmitting ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReviewModal;